var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jds-popover font-sans-1"},[_c('div',{ref:"activator",staticClass:"jds-popover__activator"},[_vm._t("activator",null,null,_vm.activatorSlotProps)],2),_c('br'),_c('div',{key:"popoverContent",ref:"content",class:{
      'jds-popover__content': true,
      'jds-popover__content--hidden': !_vm.mValue
    }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }